import React, {useEffect} from 'react';
import {Grid, List, ListItem, Typography, makeStyles} from '@material-ui/core';
import {ParameterStore} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {updateHubspotProsperDealDecisionReferredToUW, updateHubspotProsperDealGetDecision} from '../deal';
import {AgenuimContextType} from '../../../Core/agenium/ageniumContext';
import {getAgeniumFieldsForDeal} from './utils';
import FixedNavigation from './common/FixedNavigation';

interface DecisionHardStopProps {
    onExit: () => void;
    onNext: () => void;
    parameterStore: ParameterStore;
    ageniumContext: AgenuimContextType;
}
const useStyles = makeStyles(() => ({
    wrapper: {
        padding: '20px',
    },
    title: {
        fontFamily: 'LoraRegular',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '44px',
        lineHeight: '48.4px',
        color: '#456d69',
        marginBottom: '24px',
    },
    text: {
        fontFamily: 'LoraSemiBold',
        fontWeight: 700,
        fontSize: '24px',
        lineHeight: '28.8px',
        color: '#434343',
        marginBottom: '14px',
    },
    smallText: {
        fontFamily: 'FredokaLight',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '25.6px',
        color: '#838383',
        marginTop: '18px',
        marginBottom: '28px',
    },
    list: {
        fontFamily: 'FredokaRegular',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '25.6px',
        color: '#f65858',
        listStyle: 'disc',
        paddingLeft: '20px',
        marginBottom: '18px',
        '& .MuiListItem-root': {
            display: 'list-item',
            paddingLeft: '4px',
        },
    },
    navigation: {
        marginTop: '20px',
    },
    backBtn: {
        borderRadius: '20px',
    },
    nextBtn: {
        minWidth: '400px',
        borderRadius: '20px',
    },
}));

const DecisionHardStop: React.FC<DecisionHardStopProps> = ({onExit, onNext, parameterStore, ageniumContext}) => {
    const classes = useStyles();

    ageniumContext
        .updateApplicationData(
            {
                ageniumFields: getAgeniumFieldsForDeal(ageniumContext.applicationData),
            },
            parameterStore.formid,
        )
        .finally(() => {
            updateHubspotProsperDealGetDecision().then(() => {
                updateHubspotProsperDealDecisionReferredToUW();
            });
        });

    useEffect(() => {
        ageniumContext.initSdk();
    }, []);

    // end TODO
    return (
        <Grid container classes={{root: classes.wrapper}}>
            <Typography classes={{root: classes.title}}>We found a discrepancy</Typography>
            <Grid container>
                <Grid item xs={9}>
                    <Typography classes={{root: classes.smallText}}>
                        There's a discrepancy between the information you provided and the details from our verification
                        partners. Unfortunately we won’t be able to proceed with the application.
                    </Typography>
                    <Typography classes={{root: classes.text}}>
                        This is likely due to one of the following reasons:
                    </Typography>
                    <List disablePadding classes={{root: classes.list}}>
                        <ListItem>Identity information provided does not match our records</ListItem>
                        <ListItem>Identity information provided is not valid</ListItem>
                    </List>
                </Grid>
            </Grid>
            <FixedNavigation onNextCustomText="Return to Clients" onNext={onNext} isLoading={false} />
        </Grid>
    );
};

export default DecisionHardStop;
